import {domain} from './../config';

export const getCookieConsent = (state) => state[domain];